<template>
  <div class="cmp-shopping-cart-control utlz-reset">
    <!-- BESPOKE GS-548: Changed click to mouseover -->
    <div class="icon-wrapper" @mouseover="toggleCart()">
      <!-- END BESPOKE GS-548 -->
      <i class="uws-icon uws-cart" aria-hidden="true"></i>
      <span class="total-counter btn-u">{{ totalProductsCount }}</span>
    </div>

    <transition name="fadein-cart">
      <div v-if="cartOpen">
        <!-- BESPOKE GS-548: Changed click to mouseover -->
        <div @mouseover="toggleCart()" class="close-target"></div>
        <!-- END BESPOKE GS-548 -->

        <div class="shopping-cart-panel">

          <span class="close-button close-panel-mobile" @click="toggleCart()">
            <i class="fa fa-close" aria-hidden="true"></i>
          </span>

          <div class="panel-header flex-row-nowrap align-baseline">
            <i class="uws-icon uws-cart" aria-hidden="true"></i>
            <h2>
              <span v-translation="{ type: 'title', code: 'title_shopping_cart_header' }"></span>
              <span class="counter">({{ totalProductsCount }})</span>
            </h2>
          </div>

          <!-- BESPOKE GS-548: Moved button to top of the shopping cart panel, and added || bespokeUserInformation.isRepresentative  -->
          <div v-if="showOrderLines || bespokeUserInformation.isRepresentative" class="actions">
            <a :href="shoppingCartUrl" class="button theme-primary block">
              <i class="uws-icon uws-cart" aria-hidden="true"></i>
              <span v-translation="{ type: 'button', code: 'button_view_shopping_cart' }"></span>
            </a>
          </div>
          <!-- END BESPKOE GS-548 -->

          <div v-if="loadingOrderLines">
            <div v-for="index in 4" :key="index" class="ph-silhouette utlz-row">
              <span class="silhouette-img utlz-col-2"></span>
              <div class="ph-paragraph utlz-col-10">
                <span class="silhouette-line"></span>
                <span class="silhouette-line"></span>
              </div>
            </div>
          </div>

          <template v-if="showOrderLines">
            <ul class="order-lines">
              <li v-for="orderLine in orderLines" :key="orderLine.lineId" class="orderline-row flex-row-nowrap">
                <div v-if="!hideShoppingCartImages" class="prod-img">
                  <img :src="orderLine.product.imageUrl ? orderLine.product.imageUrl : '/documents/productimages/not-available-small.jpg'" />
                </div>
                <div class="prod-desc">
                  <a :href="orderLine.product.targetUrl">
                    <h3 class="prod-title header-small">{{ orderLine.product.shortDescription }}</h3>
                  </a>
                  <!-- BESPOKE GS-548: Wrapped price and quantity in div.product-quantity -->
                  <div class="product-quantity">                    
                    <span class="quantity">{{ orderLine.computedQuantity }} x</span>
                    <utlz-product-price
                      :prices="orderLine.product.prices[0]"
                      v-if="orderLine.product.prices.length"
                    ></utlz-product-price>
                  </div>
                  <!-- END BESPOKE GS-548 -->
                </div>
                <div class="delete" v-if="orderLine.customFields.original_line_number == '' || orderLine.customFields.original_line_number == undefined">
                  <!-- BESPOKE GS-574: added stockCheck: false -->
                  <span class="close-button small grey" @click="deleteOrderLine({ orderLineId: orderLine.lineId, stockCheck: false })">
                    <!-- END BESPOKE GS-574 -->
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                  </span>
                </div>
              </li>
            </ul>
          </template>

          <div v-if="shoppingCartEmpty" class="empty-cart-message col-md-12">
            <h2 v-translation="{ type: 'title', code: 'title_shopping_cart_empty' }"></h2>
          </div>

          <div class="fade-white"></div>

          <utlz-shopping-cart-totals v-if="showOrderLines" :format="shoppingCartControlTotalsFormat"></utlz-shopping-cart-totals>
          
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import ShoppingCartTotals from 'src/components/webshop/shopping-cart/ShoppingCartTotals.vue';
export default {
  components: {
    'utlz-shopping-cart-totals': ShoppingCartTotals,
    'utlz-product-price': ProductPrice
  },
  data () {
    return {
      cartOpen: false
    }
  },
  computed: {
    // BESPOKE GS: Addd bespokeUserInformation
    ...mapGetters(['language', 'hideShoppingCartImages', 'bespokeUserInformation']),
    ...mapGetters('shoppingCart', ['orderLines', 'loadingOrderLines', 'totalProductsCount', 'shoppingCartEmpty', 'shoppingCartControlTotalsFormat']),
    shoppingCartUrl () {
      return `/${this.language}/webshop/paymentprocess/single_checkout.aspx`;
    },
    showOrderLines () {
      return this.orderLines.length > 0 && this.orderLines[0].product !== null;
    }
  },
  methods: {
    ...mapActions('shoppingCart', ['initShoppingCartControl', 'getShoppingCartTotalAndCount', 'deleteOrderLine']),
    toggleCart () {
      // BESPOKE GS-547
      // Add class so we can style the cart panel to overlap the topbar and avoid z-index colission
      if (!this.cartOpen) {
        window.$('.uc_header_v6').addClass('cart-open');
      } else {
        window.$('.uc_header_v6').removeClass('cart-open');
      }
      // END BESPOKE GS-547
      this.cartOpen = !this.cartOpen;
      const shoppingCartOverviewLoaded = window.vue.modules.shoppingCartOverview;
      if (this.cartOpen && !shoppingCartOverviewLoaded) {
        this.initShoppingCartControl();
      }
    }
  },
  created () {
    this.getShoppingCartTotalAndCount();
  }
};
</script>

<style>
</style>
